document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('MenuDrawer');
  const openBtn = document.querySelector('.menu-toggle');
  const closeBtn = document.querySelector('.menu-close');
  const overlay = document.querySelector('.menu-drawer__overlay');

  if (!drawer || !openBtn) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  }

  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.wishlist-button');

  let wishlist = JSON.parse(localStorage.getItem('aisbeautybox_wishlist') || '[]');

  buttons.forEach(function (button) {
    const handle = button.dataset.productHandle;

    if (wishlist.some(item => item.handle === handle)) {
      button.textContent = '♥';
      button.classList.add('is-saved');
    }

    button.addEventListener('click', function () {
      const item = {
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage,
price: button.dataset.productPrice
      };

      const index = wishlist.findIndex(saved => saved.handle === item.handle);

      if (index >= 0) {
        wishlist.splice(index, 1);
        button.textContent = '♡';
        button.classList.remove('is-saved');
      } else {
        wishlist.push(item);
        button.textContent = '♥';
        button.classList.add('is-saved');
      }

      localStorage.setItem('aisbeautybox_wishlist', JSON.stringify(wishlist));
    });
  });
});